<template>
  <div class="preview">
    <!-- 图片 -->
    <div v-if="!isError && data.type === 1" class="img-cont">
      <img :src="data.cosPath" alt="" @click="previewImg" />
    </div>
    <!-- 视频 -->
    <div v-if="!isError && data.type === 2" class="video-cont">
      <img
        v-if="!videoIsplay"
        class="play"
        src="@/assets/img/material/icon_play.png"
        alt=""
        @click="playVideo"
      />
      <img
        v-if="!videoIsplay"
        class="preload"
        :src="data.videoCoverUrl"
        alt=""
      />
      <video ref="videoRef" :src="data.cosPath" controls></video>
    </div>
    <!-- 图文 -->
    <div v-if="!isError && data.type === 3" class="imgtxt-cont">
      <div class="imgtxt-title">
        {{ data.title }}
      </div>
      <div class="imgtxt-txt" v-html="data.content"></div>
    </div>
    <!-- 文件 -->
    <div v-if="!isError && data.type === 4" class="file-cont">
      <!-- 图片 -->
      <div
        v-if="data.attachment.ext === 'png' || data.attachment.ext === 'jpg'"
        class="img-cont"
      >
        <img :src="data.cosPath" alt="" @click="previewImg" />
      </div>
      <!-- 视频 -->
      <div v-if="data.attachment.ext === 'mp4'" class="video-cont">
        <img
          v-if="!videoIsplay"
          class="play"
          src="@/assets/img/material/icon_play.png"
          alt=""
          @click="playVideo"
        />
        <img
          v-if="!videoIsplay"
          class="preload"
          :src="data.videoCoverUrl"
          alt=""
        />
        <video ref="videoRef" :src="data.cosPath" controls></video>
      </div>
      <!-- 音频 -->
      <div
        v-if="data.attachment.ext === 'mp3' || data.attachment.ext === 'amr'"
        class="audio-cont"
      >
        <audio :src="data.cosPath" controls></audio>
      </div>
      <!-- pdf -->
      <div v-if="data.attachment.ext === 'pdf'" class="pdf-cont">
        <div class="pdf-outer-container">
          <previewPdf
            :pdf-url="pdfUrl"
            :title="title"
            @downloadPDF="downloadPDF"
          ></previewPdf>
        </div>
      </div>
      <!-- zip、psd -->
      <div
        v-if="data.attachment.ext === 'zip' || data.attachment.ext === 'psd'"
        class="zippsd-cont"
      >
        <img src="@/assets/img/material/icon_zip.png" alt="" />
        <div class="name">{{ data.attachment.name }}</div>
        <div class="size">
          {{ formatFileSize(data.attachment.size) }}
        </div>
        <div class="tips">暂不支持查看此类文件，请至电脑端进行下载查看</div>
      </div>
      <!-- doc、docx、xls、xlsx、ppt、pptx -->
      <div
        v-if="
          data.attachment.ext === 'docx' ||
            data.attachment.ext === 'doc' ||
            data.attachment.ext === 'xlsx' ||
            data.attachment.ext === 'xls' ||
            data.attachment.ext === 'ppt' ||
            data.attachment.ext === 'pptx'
        "
        class="office-cont"
      >
        <img
          v-if="data.attachment.ext === 'docx' || data.attachment.ext === 'doc'"
          src="@/assets/img/material/icon_word.png"
          alt=""
        />
        <img
          v-if="data.attachment.ext === 'xlsx' || data.attachment.ext === 'xls'"
          src="@/assets/img/material/icon_excel.png"
          alt=""
        />
        <img
          v-if="data.attachment.ext === 'ppt' || data.attachment.ext === 'pptx'"
          src="@/assets/img/material/icon_ppt.png"
          alt=""
        />
        <div class="name">{{ data.attachment.name }}</div>
        <div class="size">
          {{ formatFileSize(data.attachment.size) }}
        </div>
        <div class="btn" @click="previewFile">下载</div>
      </div>
    </div>
    <!-- 水印 -->
    <vue-watermark
      v-if="!isError && data.type === 3 && data.withWatermark === 1"
      :text="name"
      :font-size="16"
      :line-height="24"
      :width="100"
      :height="60"
      :angle="-15"
      :opacity="0.1"
    />
    <!-- 无权限 -->
    <div v-if="isError && !data.type" class="permission">
      <img class="error" src="@/assets/img/material/icon_error.png" alt="" />
      <div class="txt">{{ txt }}</div>
    </div>
  </div>
</template>

<script>
import { Toast, ImagePreview } from "vant";
import { getMaterialDetailsApi, get2BApi } from "@/api/modules/material";
import { getWechatEnv, vaildatePc, browseEvent } from "@/utils/utils";
import VueWatermark from "vue-watermark";
import previewPdf from "./components/preview-pdf.vue";
import { encodeURI } from "js-base64";
import dayjs from "dayjs";

export default {
  name: "Preview",
  components: {
    previewPdf,
    VueWatermark,
  },
  data() {
    return {
      channel: getWechatEnv(), // 企微1 微信2
      userInfo: JSON.parse(sessionStorage.getItem("userInfo")),
      id: this.$route.query.id,
      shareKey: this.$route.query.shareKey,
      data: {}, // 素材数据
      pdfUrl: "",
      name: "", // 水印内容
      isError: false,
      txt: "",
      videoIsplay: false,
      title: "", // pdf素材名
      watermarkText: "",
      startTime: dayjs(), // 开始时间
      page_url: window.location.href, // 页面链接
      page_id: window.location.pathname, // 页面唯一标识
    };
  },
  created() {
    this.getMaterialDetails();
  },
  beforeRouteLeave(to, from, next) {
    // 埋点 素材详情页 浏览开始
    browseEvent({
      tab_name: "素材", // tab名称
      page_name: "素材详情页", // 页面名
      page_url: this.page_url, // 页面链接
      page_id: this.page_id, // 页面唯一标识
      material_id: this.data.id, // 素材ID
      material_name: this.data.title, // 素材标题
      material_format: this.data.format, // 素材格式
      end_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 结束时间
      view_time: dayjs().diff(this.startTime, "second"), // 页面停留时长
    });
    next();
  },
  methods: {
    // 格式化文件大小
    formatFileSize(sizeInKB) {
      // 定义单位数组和对应的字节数
      const units = ["KB", "MB", "GB", "TB"];
      const thresholds = [1, 1024, 1024 * 1024, 1024 * 1024 * 1024];
      // 确定使用哪个单位
      let unitIndex = 0;
      while (
        sizeInKB >= thresholds[unitIndex + 1] &&
        unitIndex < units.length - 1
      ) {
        unitIndex++;
      }
      // 计算转换后的值并处理精度问题
      const size = sizeInKB / thresholds[unitIndex];
      const formattedSize = parseFloat(size.toFixed(2));
      // 返回格式化后的字符串
      return `${formattedSize} ${units[unitIndex]}`;
    },
    // 获取素材详情
    async getMaterialDetails() {
      // 通过id获取详情
      if (this.id) {
        const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
        const res = await get2BApi({
          id: this.id,
        });
        if (res.code === 0) {
          if (res.data.type === 1) {
            this.data = {
              ...res.data,
              pictures: JSON.parse(res.data.pictures[0]),
              format: JSON.parse(res.data.pictures[0]).ext,
            };
          } else if (res.data.type === 2) {
            this.data = {
              ...res.data,
              videos: JSON.parse(res.data.videos[0]),
              format: JSON.parse(res.data.videos[0]).ext,
            };
          } else if (res.data.type === 3) {
            this.name = res.data.watermarkContent;
            this.data = {
              ...res.data,
              withWatermark: 1,
            };
          } else if (res.data.type === 4) {
            this.data = {
              ...res.data,
              attachment: JSON.parse(res.data.attachment[0]),
              format: JSON.parse(res.data.attachment[0]).ext,
            };
            if (this.data.attachment.ext === "pdf") {
              // 有水印
              if (this.data.isWatermark === 1) {
                const watermarkText = `${userInfo.name}${userInfo.userId.slice(
                  -4
                )}`;
                sessionStorage.setItem("watermarkText", watermarkText);
                this.watermarkText = watermarkText;
              }
              this.pdfUrl = res.data.cosPath;
              this.title = this.data.title;
            }
          }
          document.title = this.data.title;
        } else if (res.code === 200001 || res.code === 50002) {
          // 无权限
          this.txt = "无访问权限，请联系管理员";
          this.isError = true;
        }
      } else {
        // 通过key获取详情 企微是userID 微信 openId
        const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));

        const res = await getMaterialDetailsApi({
          key: this.shareKey.replaceAll(" ", "+"),
          userId:
            this.channel === 1
              ? userInfo.userId
              : this.channel === 2
              ? userInfo.openid
              : "",
          channel: this.channel,
          terminalType: vaildatePc() ? 1 : 2, // 1pc 2移动
        });
        if (res.code === 0) {
          if (res.data.type === 1) {
            this.data = {
              ...res.data,
              pictures: JSON.parse(res.data.pictures[0]),
              format: JSON.parse(res.data.pictures[0]).ext,
            };
          } else if (res.data.type === 2) {
            this.data = {
              ...res.data,
              videos: JSON.parse(res.data.videos[0]),
              format: JSON.parse(res.data.videos[0]).ext,
            };
          } else if (res.data.type === 3) {
            if (this.$route.query.userId) {
              // 客户
              this.name = res.data.watermarkContent;
              this.data = res.data;
            }
            if (this.$route.query.name) {
              this.name = res.data.watermarkContent;
              this.data = {
                ...res.data,
                withWatermark: 1,
              };
            }
          } else if (res.data.type === 4) {
            this.data = {
              ...res.data,
              attachment: JSON.parse(res.data.attachment[0]),
              format: JSON.parse(res.data.attachment[0]).ext,
            };
            if (this.data.attachment.ext === "pdf") {
              // 有水印
              if (this.data.isWatermark === 1) {
                sessionStorage.setItem(
                  "watermarkText",
                  res.data.watermarkContent
                );
                this.watermarkText = res.data.watermarkContent;
              }
              this.title = this.data.title;
              this.pdfUrl = res.data.cosPath;
            }
          }
          document.title = this.data.title;
        } else {
          this.txt = "素材已过有效期";
          this.isError = true;
        }
      }
      // 埋点 素材详情页 浏览开始
      browseEvent({
        tab_name: "素材", // tab名称
        page_name: "素材详情页", // 页面名
        page_url: this.page_url, // 页面链接
        page_id: this.page_id, // 页面唯一标识
        material_id: this.data.id, // 素材ID
        material_name: this.data.title, // 素材标题
        material_format: this.data.format, // 素材格式
        start_time: dayjs().format("YYYY-MM-DD HH:mm:ss"), // 开始时间
      });
    },
    // 预览图片
    previewImg() {
      ImagePreview([this.data.cosPath]);
    },
    // 预览文件
    previewFile() {
      window.open(this.data.cosPath);
    },
    // 播放视频
    playVideo() {
      this.videoIsplay = true;
      this.$refs.videoRef.play();
    },
    // 下载PDF
    async downloadPDF() {
      try {
        Toast.loading({
          message: "下载中...",
          forbidClick: true,
        });
        await this.$nextTick();

        const baseUrl = this.pdfUrl.split("?")[0];
        const decodedSign = decodeURIComponent(this.pdfUrl.split("sign=")[1]);
        const urlSafeBase64 = encodeURI(this.watermarkText);

        const url =
          baseUrl +
          `?${decodedSign}` + // 签名参数
          `&ci-process=doc-preview&dstType=watermark&type=2` +
          `&text=${urlSafeBase64}` + // 水印内容（编码后）
          `&batch=1&degree=30&dissolve=30`; // 平铺+旋转+透明度

        console.log(url);

        const response = await fetch(url);
        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = `${this.title}.pdf`;
        document.body.appendChild(a);
        a.click();

        setTimeout(() => {
          document.body.removeChild(a);
          URL.revokeObjectURL(blobUrl);
        }, 100);
      } catch (error) {
        console.error("生成PDF失败:", error);
      } finally {
        Toast.clear();
      }
    },
  },
};
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}
.preview {
  width: 100%;
  height: 100vh;
  .img-cont {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    img {
      width: 100%;
    }
  }
  .video-cont {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    .play {
      position: absolute;
      width: 54px;
      height: 54px;
      z-index: 3;
    }
    .preload {
      position: absolute;
      width: 100%;
      z-index: 2;
    }
    video {
      position: absolute;
      width: 100%;
      z-index: 1;
    }
  }
  .imgtxt-cont {
    height: 100%;
    padding: 20px;
    overflow-y: auto;
    .imgtxt-title {
      font-weight: 500;
      font-size: 16px;
      color: #3d3d3d;
      margin-bottom: 16px;
    }
    .imgtxt-txt {
      font-size: 14px;
      color: #666666;
      line-height: 18px;
      ::v-deep img {
        width: 100%;
      }
      ::v-deep p {
        word-break: break-all;
      }
    }
  }
  .file-cont {
    width: 100%;
    height: 100%;
    .zippsd-cont {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding-top: 100px;
      img {
        width: 66px;
        height: 66px;
        margin-bottom: 10px;
      }
      .name {
        font-size: 28px;
        margin-bottom: 10px;
      }
      .size {
        font-size: 16px;
        margin-bottom: 20px;
      }
      .tips {
        font-size: 14px;
        color: #333333;
        line-height: 24px;
      }
    }
    .pdf-cont {
      width: 100%;
      height: 100%;
      overflow: hidden; /* 隐藏内部滚动条 */
      .pdf-outer-container {
        width: 100%;
        height: 100%;
        overflow: auto;
      }
    }
    .audio-cont {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 40%;
    }
    .office-cont {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 100px 20px 0;
      img {
        width: 66px;
        height: 66px;
        margin-bottom: 10px;
      }
      .name {
        font-size: 26px;
        text-align: center;
        margin-bottom: 10px;
      }
      .size {
        font-size: 16px;
        margin-bottom: 20px;
      }
      .btn {
        width: 100px;
        height: 33px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #f26147;
        cursor: pointer;
        font-size: 12px;
        color: #f26147;
        text-align: center;
        line-height: 32px;
      }
    }
  }
  .permission {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 120px;
    .error {
      width: 240px;
      height: 191px;
      margin-bottom: 24px;
    }
    .txt {
      font-size: 14px;
      color: #333333;
      line-height: 24px;
      text-align: center;
    }
  }
}
</style>
